import { _initialDepartments } from '../../../fixtures/departmentFixtures';
import { _initialProjectPhase } from '../../../fixtures/projectFixtures';
import { IPagination } from '../../../types/pagination';
import { statusColor } from '../../../utils/statusColor';
import * as constants from '../actions/constants';
import { DirectAndPassTroughCostActions } from '../actions/directAndPassTroughCosts';
import { ProjectActions } from '../actions/projectActions';
import { IDirectCost, IMilestone, IMilestoneOfferDirectCost, IMilestoneOfferDirectCostMonths, IMilestoneOfferDirectCostUpdate, IMilestoneSortColumn, IPassThroughCost } from '../types/directAndPassTroughCosts';
import { IDirectCostsBulk, IOfferDirectCostsBulk, IOfferPassThroughCostsBulk, IPassTroughCostsBulk } from '../types/project';
import { _SPT_BUDGET_TABS } from './../containers/budget/service-provider/ServiceProviderBudgetListContainer';
import { ICostFilter, ICostHistory, ICostSearch, ICostSorting, ICostsSortColumn, IOfferDirectCost, IOfferPassThroughCost } from './../types/directAndPassTroughCosts';

export const _initialDirectCost: IDirectCost = {
  id: '',
  offer_position: '',
  project_phase: _initialProjectPhase[0],
  department: _initialDepartments[0],
  quantity: '',
  unit_hours: '',
  unit_price: '',
  start_date: null,
  end_date: null,
  last_start_date: null,
  last_end_date: null,
  total_hours: 0,
  current_hours: 0,
  expenditures: 0,
  status: 'upcoming',
  assigned_employees: [],
  labels: [],
  remainingHours: '',
  remainingHoursPercentage: '',
  statusColor: (status: string) => statusColor(status),
  time_completion: 0
}

const _initialPaginationDirectCost: IPagination<IDirectCost[]> = {
  links: { next: '', previous: '' },
  count: 0,
  current_page: 0,
  total_pages: 0,
  results: [_initialDirectCost],
  page_size: 5,
  last_page: 0,
  to: 0,
  from: 0
}

export const _initialPassTroughCost: IPassThroughCost = {
  id: '',
  offer_position: '',
  project_phases: _initialProjectPhase,
  supplier: '',
  quantity: '',
  unit_price: '',
  start_date: null,
  end_date: null,
  last_start_date: null,
  last_end_date: null,
  total_hours: 0,
  current_hours: 0,
  expenditures: 0,
  assigned_employees: [],
  labels: [],
  remainingHours: '',
  remainingHoursPercentage: '',
  statusColor: (status: string) => statusColor(status),
  time_completion: 0,
  total_cost: 0,
  thereof_paid: 0,
  position_status: 'open',
  passed_through_amount: 0,
  payments: []
}

export const _initialCostSort: ICostSorting = {
  clustering: 'phase',
  column: { name: 'offer_position', direction: 'asc' } as ICostsSortColumn
}

export const _initialMilestone: IMilestone = {
  id: -1,
  name: '',
  date: '',
  tasks: []
}

export const _initialMilestoneOfferDirectCost: IMilestoneOfferDirectCost = {
  id: -1,
  milestone: {} as IMilestone,
  offer_direct_cost: {} as IOfferDirectCost,
  offered: 0,
  planned: 0,
  performed: 0,
  planned_per_unit: 0,
  spent_per_unit: 0,
}

export const directCosts = (state: IDirectCost[] = [], action: DirectAndPassTroughCostActions | ProjectActions): IDirectCost[] => {
  switch (action.type) {
    case constants.CLEAN_PROJECT_STATE:
      return []
    case constants.GET_DIRECT_COSTS_SUCCESS:
    case constants.PROJECT_LABELS_MERGE_TASKS_DIRECT_COSTS_SUCCESS:
      return action.direct_costs

    case constants.UPDATE_DIRECT_COST_SUCCESS:
    case constants.GET_DIRECT_COST_SUCCESS:
      return state.map(a => {
        if (+a.id === +action.cost.id) {
          return action.cost
        }
        return a
      })

    case constants.CREATE_DIRECT_COST_SUCCESS:
      return [...state, action.cost]

    default:
      return state
  }
}

export const directCost = (state: IDirectCost = _initialDirectCost, action: DirectAndPassTroughCostActions | ProjectActions): IDirectCost => {
  switch (action.type) {
    case constants.CLEAN_PROJECT_STATE:
      return _initialDirectCost
    case constants.GET_DIRECT_COST_SUCCESS:
      return action.cost

    case constants.UPDATE_DIRECT_COST_SUCCESS:
      return action.cost
    default:
      return state
  }
}

export const passTroughCosts = (state: IPassThroughCost[] = [], action: DirectAndPassTroughCostActions | ProjectActions): IPassThroughCost[] => {
  switch (action.type) {
    case constants.CLEAN_PROJECT_STATE:
      return []
    case constants.GET_PASS_TROUGH_COSTS_SUCCESS:
      return action.pass_trough_costs

    case constants.UPDATE_PASS_TROUGH_COST_SUCCESS:
      return state.map(a => {
        if (+a.id === +action.cost.id) {
          return action.cost
        }
        return a
      })

    case constants.CREATE_PASS_TROUGH_COST_SUCCESS:
      return [...state, action.cost]

    default:
      return state
  }
}

export const passTroughCost = (state: IPassThroughCost = _initialPassTroughCost, action: DirectAndPassTroughCostActions | ProjectActions): IPassThroughCost => {
  switch (action.type) {
    case constants.CLEAN_PROJECT_STATE:
      return _initialPassTroughCost
    case constants.GET_PASS_TROUGH_COST_SUCCESS:
      return action.cost

    default:
      return state
  }
}

export const selectedCost = (state: IDirectCost | IPassThroughCost = _initialDirectCost, action: DirectAndPassTroughCostActions | ProjectActions): IDirectCost | IPassThroughCost => {
  switch (action.type) {
    case constants.CLEAN_PROJECT_STATE:
      return _initialDirectCost
    case constants.SET_SELECTED_COST:
    case constants.UPDATE_DIRECT_COST_SUCCESS:
    case constants.UPDATE_PASS_TROUGH_COST_SUCCESS:
    case constants.GET_DIRECT_COST_SUCCESS:
      return action.cost

    default:
      return state
  }
}

export const costFilters = (state: ICostFilter[] = [] as ICostFilter[], action: DirectAndPassTroughCostActions): ICostFilter[] => {
  switch (action.type) {
    case constants.GET_COSTS_FILTERS_SUCCESS:
      return action.filters

    case constants.SET_COSTS_FILTERS: {
      const { filter, queryOptions } = action
      return state.map(f => {
        if (f.name === filter.name) {
          const idx = f.options.findIndex(o => o.name === queryOptions.name)
          if (idx !== -1) {
            if (f.name === 'Due Date' || f.name === 'Status') {
              f.options = f.options.map((o, i) => ({ ...o, selected: i !== idx ? false : o.selected }))
              if (f.options[idx].value === 'individual') {
                f.options[idx].start_date = queryOptions.start_date
                f.options[idx].end_date = queryOptions.end_date
              }
            }
            f.options[idx].selected = f.options[idx].start_date || f.options[idx].end_date ? true : !f.options[idx].selected
          }
        }
        return f
      })
    }

    case constants.CLEAR_COST_FILTERS: {
      const b = state.map(f => {
        const _o = f.options.map(o => {
          return { ...o, selected: false }
        })
        return { ...f, options: _o }
      })

      return b
    }

    default:
      return state
  }
}

export const sortCosts = (state: ICostSorting = _initialCostSort, action: DirectAndPassTroughCostActions): ICostSorting => {
  switch (action.type) {
    case constants.SORT_COSTS:
      return action.sorting

    default:
      return state
  }
}

export const dcInDangerSorting = (state: ICostSorting = _initialCostSort, action: DirectAndPassTroughCostActions): ICostSorting => {
  switch (action.type) {
    case constants.SORT_DC_IN_DANGER:
      return action.sorting

    default:
      return state
  }
}

export const searchCosts = (state = { search: '' }, action: DirectAndPassTroughCostActions): ICostSearch => {
  switch (action.type) {
    case constants.SEARCH_COSTS:
      return action.filter

    default:
      return state
  }
}

export const openCostDetailsModal = (state = false, action: DirectAndPassTroughCostActions): boolean => {
  switch (action.type) {
    case constants.SET_OPEN_COST_DETAILS_MODAL:
      return action.open

    default:
      return state
  }
}

export const costHistory = (state: ICostHistory[] = [], action: DirectAndPassTroughCostActions): ICostHistory[] => {
  switch (action.type) {
    case constants.GET_DIRECT_COST_HISTORY_SUCCESS:
    case constants.GET_PASS_TROUGH_COST_HISTORY_SUCCESS:
      return action.history.sort((a, b) =>  b.history_id - a.history_id)

    case constants.RESET_DIRECT_COST_HISTORY:
    case constants.RESET_PASS_TROUGH_COST_HISTORY:
      return []

    default:
      return state
  }
}

export const updatedDirectCosts = (state: IDirectCostsBulk = {to_create: [], to_update: [], to_delete: []}, action: DirectAndPassTroughCostActions): IDirectCostsBulk => {
  switch (action.type) {
    case constants.SET_BULK_DIRECT_COSTS:
      return action.costs

    default:
      return state
  }
}

export const updatedOfferDirectCosts = (state: IOfferDirectCostsBulk = {to_create: [], to_update: [], to_delete: []}, action: DirectAndPassTroughCostActions): IOfferDirectCostsBulk => {
  switch (action.type) {
    case constants.SET_OFFER_BULK_DIRECT_COSTS:
      return action.costs

    default:
      return state
  }
}

export const updatedPassTroughCosts = (state: IPassTroughCostsBulk = {to_create: [], to_update: [], to_delete: []}, action: DirectAndPassTroughCostActions): IPassTroughCostsBulk => {
  switch (action.type) {
    case constants.SET_BULK_PASS_TROUGH_COSTS:
      return action.costs

    default:
      return state
  }
}

export const updatedOfferPassTroughCosts = (state: IOfferPassThroughCostsBulk = {to_create: [], to_update: [], to_delete: []}, action: DirectAndPassTroughCostActions): IOfferPassThroughCostsBulk => {
  switch (action.type) {
    case constants.SET_OFFER_BULK_PASS_THROUGH_COSTS:
      return action.costs

    default:
      return state
  }
}

export const activeSPTBudgetTab = (state = _SPT_BUDGET_TABS[0].key, action: DirectAndPassTroughCostActions): string => {
  switch (action.type) {
    case constants.SET_ACTIVE_SPT_BUDGET_TAB:
      return action.tab

    default:
      return state
  }
}

export const offerDirectCosts = (state: IOfferDirectCost[] = [], action: DirectAndPassTroughCostActions | ProjectActions): IOfferDirectCost[] => {
  switch (action.type) {
    case constants.CLEAN_PROJECT_STATE:
      return []
    case constants.GET_OFFER_DIRECT_COSTS_SUCCESS:
      return action.offer_direct_costs

    default:
      return state
  }
}

export const offerPassTroughCosts = (state: IOfferPassThroughCost[] = [], action: DirectAndPassTroughCostActions | ProjectActions): IOfferPassThroughCost[] => {
  switch (action.type) {
    case constants.CLEAN_PROJECT_STATE:
      return []
    case constants.GET_OFFER_PASS_TROUGH_COSTS_SUCCESS:
      return action.offer_pass_trough_costs

    default:
      return state
  }
}

export const draggableIndicator = (state = false, action: DirectAndPassTroughCostActions): boolean => {
  switch (action.type) {
    case constants.SET_DRAGGABLE_INDICATOR_SUCCESS:
      return action.draggable

    default:
      return state
  }
}

export const paginatedDirectCosts = (
  state: IPagination<IDirectCost[]> = _initialPaginationDirectCost,
  action: DirectAndPassTroughCostActions | ProjectActions
): IPagination<IDirectCost[]> => {
  switch (action.type) {
    case constants.CLEAN_PROJECT_STATE:
      return _initialPaginationDirectCost
    case constants.GET_PAGINATED_DIRECT_COSTS_SUCCESS:
      return action.direct_costs

    default:
      return state
  }
}

export const paginatedDirectCostsActivePage = (state = 1, action: DirectAndPassTroughCostActions): number => {
  switch (action.type) {
    case constants.SET_PAGINATED_DIRECT_COSTS_ACTIVE_PAGE:
      return action.page

    default:
      return state
  }
}

export const milestoneView = (state: 'overview' | 'unit_tracker' = 'overview', action: DirectAndPassTroughCostActions): 'overview' | 'unit_tracker' => {
  switch (action.type) {
    case constants.SET_MILESTONE_VIEW_SUCCESS:
      return action.view

    default:
      return state
  }
}

export const sortMilestoneClusteredTasks = (state: IMilestoneSortColumn = { name: 'offer_position', direction: 'asc' }, action: DirectAndPassTroughCostActions): IMilestoneSortColumn => {
  switch (action.type) {
    case constants.SET_MILESTONE_SORT_SUCCESS:
      return action.sort

    default:
      return state
  }
}

export const milestoneOfferDirectCosts = (state: IMilestoneOfferDirectCost[] = [], action: DirectAndPassTroughCostActions): IMilestoneOfferDirectCost[] => {
  switch (action.type) {
    case constants.GET_MILESTONE_OFFER_DIRECT_COSTS_SUCCESS:
    case constants.MILESTONE_OFFER_DIRECT_COSTS_UPDATE_SUCCESS:
    case constants.MILESTONE_OFFER_DIRECT_COSTS_RESET:
      return action.tasks

    default:
      return state
  }
}

export const milestones = (state: IMilestone[] = [], action: DirectAndPassTroughCostActions | ProjectActions): IMilestone[] => {
  switch (action.type) {
    case constants.GET_PROJECT_SUCCESS:
      return []
    case constants.GET_MILESTONES_SUCCESS:
      return action.milestones

    case constants.DELETE_MILESTONE_SUCCESS:
      return state.filter(m => m.id !== action.milestone.id)

    case constants.UPDATE_MILESTONE_SUCCESS:
      return state.map(m => {
        if (+m.id === +action.milestone.id) {
          return action.milestone
        }
        return m
      })

    case constants.CREATE_MILESTONE_SUCCESS:
      return [
        ...state.map(s => ({
          ...s,
          tasks: s.tasks.filter(task => {
            const milestoneTaskIds = action.milestone.tasks.map(t => t.offer_direct_cost.id)
            return !milestoneTaskIds.includes(+task.offer_direct_cost.id)
          })
        })),
        action.milestone
      ]

    default:
      return state
  }
}

export const milestoneOfferDirectCostsForUpdate = (state: IMilestoneOfferDirectCostUpdate[] = [], action: DirectAndPassTroughCostActions): IMilestoneOfferDirectCostUpdate[] => {
  switch (action.type) {
    case constants.SET_MILESTONE_OFFER_DIRECT_COSTS_UPDATE_SUCCESS:
      return action.tasks

    case constants.MILESTONE_OFFER_DIRECT_COSTS_UPDATE_SUCCESS:
      return []

    default:
      return state
  }
}

export const milestoneUnitTracker = (state: IMilestoneOfferDirectCostMonths[] = [], action: DirectAndPassTroughCostActions): IMilestoneOfferDirectCostMonths[] => {
  switch (action.type) {
    case constants.GET_MILESTONE_UNIT_TRACKER_SUCCESS:
      return action.tracker

    default:
      return state
  }
}
